<template>
  <div class="sirui-table table-top" style="width: 100%">
    <vxe-toolbar
      ref="VxeToolbar"
      :data="data"
      size="mini"
      v-if="showToolbar || filterEmptyButtonList.length != 0"
      :id="$route.path"
      :custom="setting ? { immediate: false, isFooter: false } : false"
    >
      <template v-slot:buttons>
        <template v-for="(item, i) in filterEmptyButtonList">
          <vxe-button
            v-if="item.type == '0'"
            type="primary"
            className="table-btn"
            :disabled="item.isDisabled"
            :key="i"
            :style="
              'background-color:' +
              (item.label == '删除' || item.label == '禁用' || item.label == '禁用(子类)'
                ? '#FE8783'
                : 'rgb(98, 153, 254)') +
              ';border:1px solid ' +
              (item.label == '删除' || item.label == '禁用' || item.label == '禁用(子类)'
                ? '#FE8783'
                : 'rgb(98, 153, 254)')
            "
            @click="chooseClick(item.attributes.buttonUrl, item)"
          >
            <!-- <svg-icon
              v-if="item.attributes.buttonStyle"
              class="icon-img"
              style="font-size: 16px; padding-right: 6px"
              :icon-class="item.attributes.buttonStyle"
            /> -->
            {{ item.label }}
          </vxe-button>
        </template>
        <!--自定义按钮-->
        <slot name="customer-button"></slot>
      </template>
      <!--自定义列配置-->
      <template v-if="customVisible" v-slot:tools>
        <sirui-columns
          :columns="siruiColumns"
          @setColumns="setColumns"
          @getTableColumn="getTableColumn"
        ></sirui-columns>
      </template>
      <template v-slot:cardButtons></template>
    </vxe-toolbar>
    <!-- 仅仅是占位作用,当上面不存在的时候为了表格和上面的表单分开下 -->
    <el-row v-else style="width: 100%; height: 40px"></el-row>
    <div class="public-table" style="width: 100%">
      <vxe-table
        :data="data"
        :auto-resize="true"
        resizable
        border="outer"
        column-key
        size="mini"
        keep-source
        show-overflow
        show-header-overflow
        highlight-current-row
        highlight-hover-row
        ref="xTable"
        stripe
        :row-id="rowKey"
        :row-config="{ isCurrent: true, isHover: true }"
        column-min-width="120"
        :height="heightNew"
        :max-height="maxHeight"
        :fit="true"
        :show-footer="showFooter"
        :cell-style="cellStyle"
        @cell-click="cellClick"
        :loading="loading"
        :row-style="rowStyle"
        :footer-method="footerMethod"
        :span-method="spanMethod"
        :sort-config="{ remote: true }"
        :expand-config="{ accordion: true, toggleMethod: this.toggleMethod }"
        @current-change="currentChange"
        @select-change="togglePaperSelect"
        @radio-change="handleRadioChange"
        @select-all="toggleAllPaperSelect"
        @sort-change="sortChangeEvent"
        @cell-dblclick="dblclickEvent"
        :checkbox-config="{
          reserve: true,
          checkRowKeys: checkRowKeysList,
          checkMethod: checkMethod,
          ...checkboxConfig,
        }"
        :radio-config="{ checkRowKey: checkRowKeysList.join(',') }"
        :seq-config="{ startIndex: (page.pageNum - 1) * page.pageSize }"
      >
        <slot></slot>
      </vxe-table>
    </div>

    <!--:style="{'display':!paging || (paging && data.length == 0) || !data  ? 'none':'block'}"-->
    <div class="block" v-if="page.total > 0">
      <div class="left" v-if="reserve"
        >选中{{ multipleSelection.length }}条,显示第
        {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
        {{
          (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
            ? page.total
            : (page.pageNum - 1) * page.pageSize + page.pageSize
        }}
        条记录，共 {{ page.total }} 条记录</div
      >
      <div class="left" v-else
        >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
        {{
          (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
            ? page.total
            : (page.pageNum - 1) * page.pageSize + page.pageSize
        }}
        条记录，共 {{ page.total }} 条记录</div
      >
      <el-pagination
        v-if="page.total > 0"
        class="right"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handlePagination"
        :page-count="page.pages"
        :current-page="page.pageNum || 1"
        :page-sizes="pageSizes"
        :page-size="page.pageSize"
        :total="page.total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import SiruiColumns from '@/components/SiruiColumns';
  import Sortable from 'sortablejs';
  import BASE_API from '@/api/dataBase.js';
  import loading from '@/common/js/load.js'; //  loading
  import XEUtils from 'xe-utils';
  export default {
    name: 'SiruiTable',
    components: {
      SiruiColumns,
    },
    props: {
      checkboxConfig: {
        type: Object,
        default: () => {},
      },
      height: {
        type: String,
        default: () => '500',
      },
      maxHeight: {
        type: String,
        default: () => '',
      },
      //按钮列表
      buttonList: {
        type: Array,
        default: () => [],
      },
      //table数据
      data: {
        type: Array,
        default: () => [],
      },
      //row-id
      rowKey: {
        type: String,
        default: 'id',
      },
      //设置选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      //是否添加loading效果
      loading: {
        type: Boolean,
        default: false,
      },
      //是否添加foot
      showFooter: {
        type: Boolean,
        default: false,
      },
      //是否需要自定义列 插件自带的组件
      setting: {
        type: Boolean,
        default: true,
      },
      //按钮没有是否需要展示自定义列
      showToolbar: {
        type: Boolean,
        default: false,
      },
      //solt自定义的组件  需要走数据库保存
      customVisible: {
        type: Boolean,
        default: false,
      },
      //是否需要分页
      paging: {
        type: Boolean,
        default: true,
      },
      //是否需要翻页选中
      reserve: {
        type: Boolean,
        default: true,
      },
      //是否显示表头
      showHeader: {
        type: Boolean,
        default: true,
      },
      //行样式
      rowStyle: {
        type: Function,
        default: () => {},
      },
      cellStyle: {
        type: Function,
        default: () => {},
      },
      cellClick: {
        type: Function,
        default: () => {},
      },
      //foot方法
      footerMethod: {
        type: Function,
        default: () => {},
      },
      spanMethod: {
        type: Function,
        default: () => {},
      },
      //自定义列
      columns: {
        type: Array,
        default: () => [],
      },
      //自定义方法
      checkMethod: {
        type: Function,
        default: function () {
          return true;
        },
      },
      // 分页选择条数
      pageSizes: {
        type: Array,
        default: () => [10, 20, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      },
    },
    data() {
      return {
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
        heightNew: 0,
        sortable: {},
        multipleSelection: [], // 表格被选中的行数据
        siruiColumns: this.columns,
        allSelectionRows: [], // 全部选中的
        checkRowKeysList: this.checkRowKeys, // 选中的
      };
    },
    watch: {
      columns(newValue) {
        this.siruiColumns = newValue;
      },
      height(newValue) {
        this.heightNew = newValue;
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      filterEmptyButtonList() {
        return this.buttonList.filter((item) => item);
      },
    },
    beforeDestroy() {
      if (this.sortable && XEUtils.has(this.sortable, 'destroy')) {
        this.sortable.destroy();
      }
    },
    mounted() {
      this.columnDrop();
      let searchTableFlag =
        this.$parent.$parent.$el.getAttribute('class')?.indexOf('searchTable') != -1;
      // 如果是search-table弹出框则高度定死，其他则计算
      this.heightNew = searchTableFlag
        ? '300px'
        : this.height
        ? this.height
        : document.body.clientHeight - 320 + 'px' || 0;
    },
    methods: {
      columnDrop() {
        this.$nextTick(() => {
          let xTable = this.$refs.xTable;
          this.sortable = Sortable.create(
            xTable.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'),
            {
              handle: '.vxe-header--column:not(.col--fixed)',
              onEnd: ({ item, newIndex, oldIndex }) => {
                let { fullColumn, tableColumn } = xTable.getTableColumn();
                let targetThElem = item;
                let wrapperElem = targetThElem.parentNode;
                let newColumn = fullColumn[newIndex];
                if (newColumn.fixed) {
                  // 错误的移动
                  if (newIndex > oldIndex) {
                    wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex]);
                  } else {
                    wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem);
                  }
                  return this.$XModal.message({
                    message: this.$t('fix.column'),
                    status: 'error',
                  });
                }
                // 转换真实索引
                let oldColumnIndex = xTable.getColumnIndex(tableColumn[oldIndex]);
                let newColumnIndex = xTable.getColumnIndex(tableColumn[newIndex]);
                // 移动到目标列
                let currRow = fullColumn.splice(oldColumnIndex, 1)[0];
                fullColumn.splice(newColumnIndex, 0, currRow);
                xTable.loadColumn(fullColumn);
                //先要获取当前路由的菜单code
                this.getRouteMenuCode().then((e) => {
                  this.saveColumn(fullColumn, e);
                });
              },
            }
          );
        });
      },
      saveColumn(fullColumns, menuCode) {
        let { fullColumn } = this.$refs.xTable.getTableColumn();
        const baseInfo = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          departmentCode: this.userInfo.userInfo.departmentCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentName: this.userInfo.userInfo.departmentName,
          userId: this.userInfo.userInfo.userCode,
          menuCode: menuCode,
        };
        const list = fullColumn.map((item, index) => {
          return Object.assign(
            {},
            {
              ...baseInfo,
              sortNum: index,
              field: item.property,
              title: item.type == 'seq' ? 'table.index' : this.getField(item.property),
              visible: item.visible,
              sortable: item.sortable,
              type: item.type,
              width: item.width,
              fixed: item.fixed,
            }
          );
        });
        this.siruiColumns = list;
        loading.startLoading();
        this.$axios.post(BASE_API.ADD_COLUMNS_API, list).then((res) => {
          loading.endLoading();
          if (0 == res.data.code) {
            this.$refs.xTable.loadColumn(fullColumns);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取列名
      getField(value, valueProp = 'field', labelField = 'title') {
        if (value) {
          let item = XEUtils.find(this.columns, (item) => item[valueProp] == value);
          return item ? item[labelField] : null;
        } else {
          return null;
        }
      },
      //设置总条数
      setPageTotal(val) {
        this.page.total = val;
      },
      //设置页数为第一页
      setPageNum(val) {
        this.page.pageNum = val;
        console.log(val, '分页', this.allSelectionRows);
        this.$nextTick(() => {
          this.multipleSelection = this.allSelectionRows;
          this.$refs.xTable.setCheckboxRow(this.allSelectionRows, true);
          this.$refs.xTable.updateData();
        });
      },
      //设置每页显示10条
      setPageSize(val) {
        this.page.pageSize = val;
      },
      setPagesCount(val) {
        this.page.pages = val;
      },
      //抛出选择每页条数事件
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.$emit('handleSizeChange', val);
      },
      //  单个选择
      togglePaperSelect(val) {
        console.log(val, '单选');
        if (val.checked) {
          this.allSelectionRows.push({ ...val.row });
        } else {
          console.log(
            this.allSelectionRows.map((item) => item[this.rowKey]),
            '???'
          );
          this.allSelectionRows = this.allSelectionRows.filter(
            (it) => it[this.rowKey] != val.row[this.rowKey]
          );
        }
        console.log(this.allSelectionRows, '单选最后的');
        this.$emit('handleSelectionChange', this.allSelectionRows);
        this.multipleSelection = this.allSelectionRows;
      },
      // 全选
      toggleAllPaperSelect(val) {
        console.log(val, '全选');
        console.log(val.$table.afterFullData);
        if (val.checked) {
          if (this.allSelectionRows.length) {
            for (const item of val.selection) {
              const findItem = this.allSelectionRows.find(
                (it) => it[this.rowKey] == item[this.rowKey]
              );
              if (!findItem) {
                this.allSelectionRows.push(item);
              }
            }
          } else {
            this.allSelectionRows.push(...val.selection);
          }
        } else {
          this.allSelectionRows = this.allSelectionRows.filter(
            (it) =>
              !val.$table.afterFullData.map((item) => item[this.rowKey]).includes(it[this.rowKey])
          );
        }
        console.log(this.allSelectionRows, '多选最后的');
        this.$emit('handleSelectionChange', this.allSelectionRows);
        this.multipleSelection = this.allSelectionRows;
      },
      //抛出勾选框表格选中事件
      handleSelectionChange(val) {
        console.log(
          val,
          '选择',
          '当前页面选中的',
          val.selection,
          '翻页别的页面选中的',
          val.reserves
        );
        this.allSelectionRows = [...val.reserves, ...val.selection];
        this.checkRowKeysList = this.allSelectionRows.map((item) => item[this.rowKey]);
        console.log(this.allSelectionRows, '全部选中', this.checkRowKeysList);
        this.$emit('handleSelectionChange', this.allSelectionRows);
        this.multipleSelection = this.allSelectionRows;
      },
      //抛出单选表格选中事件
      handleRadioChange(val) {
        this.$emit('handleSelectionChange', [val.row]);
        this.multipleSelection = [val.row];
      },
      // 抛出展开行事件
      toggleMethod(val) {
        this.$emit('toggleMethod', val);
        return true;
      },
      //抛出表格选中事件
      currentChange(val) {
        this.$emit('currentChange', val.row);
      },
      //抛出当前页数跳转事件
      handlePagination(val) {
        console.log(val, '------>');
        this.page.pageNum = val;
        this.$nextTick(() => {
          this.multipleSelection = this.allSelectionRows;
          this.$refs.xTable.setCheckboxRow(this.allSelectionRows, true);
          this.$refs.xTable.updateData();
        });
        this.$emit('handleCurrentChange', val);
      },
      //排序
      sortChangeEvent({ column, property, order }) {
        this.$emit('sortChangeEvent', { column, property, order });
      },
      //设置选中
      toggleRowSelection() {
        this.$refs.xTable.setAllSelection(true);
      },
      //清除选中
      clearCheckboxRow() {
        this.$refs.xTable.clearCheckboxRow();
      },
      // 设置单选选中：用于 type=radio，设置某一行为选中状态
      setRadioRow(row) {
        this.$refs.xTable.setRadioRow(row);
      },
      // 用于 type=checkbox，设置行为选中状态，第二个参数为选中与否
      // rows: Row | Array<Row>, checked: boolean
      setCheckboxRow(rows, checked) {
        this.$refs.xTable.setCheckboxRow(rows, checked);
      },
      //双击单元格事件
      dblclickEvent(val) {
        // this.$refs.xTable.clostTooltip();
        this.$emit('dblclickEvent', val);
      },
      //获取当前展示的列
      getTableColumn() {
        return this.$refs.xTable.getTableColumn();
      },
      //获取checkbox选择
      getCheckboxRecords(isFull) {
        return this.$refs.xTable.getCheckboxRecords(isFull);
      },
      //获取radio选择
      getRadioRecord() {
        return this.$refs.xTable.getRadioRecord();
      },
      //清空页面所选
      clearSelectRecord() {
        this.$refs.xTable.clearRadioRow();
        this.$refs.xTable.clearCheckboxRow();
        this.multipleSelection = [];
      },
      //手动清空用户保留选中的行数据
      clearCheckboxReserve() {
        console.log('调用');
        setTimeout(() => {
          this.$refs.xTable.clearCheckboxReserve();
          this.allSelectionRows = this.multipleSelection = [];
          this.$refs.xTable.setCheckboxRow(this.allSelectionRows, true);
          this.$refs.xTable.updateData();
          // this.page.pageSize = 10;
          // this.page.pageNum = 1;
          this.$refs.xTable.reloadData(this.data);
        }, 1000);
      },
      //重新刷新表格
      reloadTable(data) {
        this.$refs.xTable.reloadData(data);
      },
      //点击按钮调用父页面方法
      chooseClick(buttonUrl) {
        this.$emit('chooseClick', buttonUrl, this.multipleSelection);
      },
      //获取翻页历史数据
      getCheckboxReserveRecords(isFull) {
        return this.$refs.xTable.getCheckboxReserveRecords(isFull);
      },
      //重新设置列数据
      setColumns(tableFullColumn) {
        let { fullColumn } = this.$refs.xTable.getTableColumn();
        fullColumn.forEach((item, index) => {
          item.visible = tableFullColumn[index]?.visible;
          // if(item.type!='checkbox'&&item.visible){
          //   fullColumn[0].visible=true;
          // }
          if (item.type == 'checkbox') item.visible = true;
        });
        this.$refs.xTable.loadColumn(fullColumn);
      },
    },
  };
</script>
<style lang="scss">
  .table-top {
    .vxe-buttons--wrapper {
      display: inline-block !important;
      padding-right: 10px;
      max-width: 1650px;
      .vxe-button:nth-of-type(15) {
        margin-top: 10px;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .sirui-table {
    padding-top: 0px;
    .vxe-toolbar {
      margin-top: 20px;
      padding: 10px 0 10px 0;
      text-align: right;
      display: flex !important;
      flex-direction: row;
      justify-content: flex-end;
      height: auto;
      ::v-deep .vxe-button--wrapper {
        flex-grow: unset !important;
      }
      ::v-deep .vxe-custom--wrapper {
        width: 100%;
        padding-left: 9px;
        margin-top: 2px;
      }
      ::v-deep .vxe-tools--wrapper {
        margin-top: -10px;
      }
      .vxe-button {
        height: 32px;
        line-height: 32px;
        min-width: 90px;
        border-radius: 3px;
        font-size: 12px;
        margin-bottom: 10px;
        ::v-deep .vxe-button--content {
          vertical-align: baseline;
        }
        margin-left: 10px;
      }
    }
    .block {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-pagination {
        display: inline-block;
      }
      .left {
        color: #999999;
        font-size: 12px;
      }
      .right {
        ::v-deep .active:hover {
          color: #ffffff !important;
        }
      }
    }
  }
  .el-pagination {
    text-align: right;
    padding-top: 10px;
    margin-bottom: 8px;
  }
</style>
